import React, { useState, useEffect,useContext,useRef } from 'react';

import CardFullView from '../GridViewMain/CardFullView/CardFullView';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { UserContext } from '../login/LoginForm';
import { getItem } from '../../utils/localStorage';
import Select from 'react-select';

import { AuthContext } from '../login/AuthContext';
import GridViewMain from '../GridViewMain/GridViewMain';
import ConfirmationModal from '../GridViewMain/ConfirmationModal';
import FilterComponent from '../GridViewMain/FilterComponent';
import NameSelect from '../GridViewMain/NameSelect';
import MoreOptionsButton from '../UsefulComponent/moreOptionButtonSingle'
import { teams } from "../CreateCardForm/teamslist";
import InfoIcon from '../UsefulComponent/InfoIcon';
// import css CardGrid2
import TradeModals from './TradeModals';

function CardGridTrade({ cards }) {
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const [showMore, setShowMore] = useState(false); // State for showing additional filter content
 //style={{border: "2px solid black",   padding: "10px",
 const { userId,liveCsrfToken } = useContext(AuthContext);
  const hasEffectRunRef = useRef(false); 
  const navigate = useNavigate();
  const [selectedAction1,setSelectedAction1] = useState("");
  const [collections, setCollections] = useState([]); // State to hold the collections array
  const [selectedCollection, setSelectedCollection] = useState("");
  const [selectedCollectionLive, setSelectedCollectionLive] = useState("");
  const [selectedCollectionTitle, setSelectedCollectionTitle] = useState("");
  const [isViewCollection, setIsViewCollection] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedCards,setSelectedCards]= useState([]);
  const [allCollectionCards,setAllCollectionCards]= useState([]);
  const [recentlyDeletedCards,setRecentlyDeletedCards]= useState([]);
  const  [isViewRecentlyDeleted, setIsViewRecentlyDeleted] = useState(false);
  const [selectedCollectionCards,setSelectedCollectionCards]= useState([]);
  const [tempoCards,setTempoCards]= useState([]);
  const [multiEditState,setMultiEditState]= useState(false);
  const [filterValues, setFilterValues] = useState({});
  // isGone: {0: true}
  const [filteredCards, setFilteredCards] = useState([]);
  const [nameCounts, setNameCounts] = useState({});

  const [setCounts, setSetCounts] = useState({});
  const [variationNameCounts, setVariationNameCounts] = useState({});
  const [cardNameCounts, setCardNameCounts] = useState({});
  const [yearCounts, setYearCounts] = useState({});
  const [isRookieCounts, setIsRookieCounts] = useState({});
  const [isPatchCounts, setIsPatchCounts] = useState({});
  const [isJerseyCounts, setIsJerseyCounts] = useState({});
  const [isAutoCounts, setIsAutoCounts] = useState({});
  const [teamsIdCounts, setTeamsIdCounts] = useState({});
  const [isForSaleCounts, setIsForSaleCounts] = useState({});
  const [isForTradeCounts, setIsForTradeCounts] = useState({});
  const [isOnEbayCounts, setIsOnEbayCounts] = useState({});
  const [isPCCounts, setIsPCCounts] = useState({});
  const [isGoneCounts, setIsGoneCounts] = useState({});
  const [isGradedCounts, setIsGradedCounts] = useState({});
  const [gradeCompanyCounts, setGradeCompanyCounts] = useState({});
  const [gradeCounts, setGradeCounts] = useState({});
  const [selectedCollectionInnerText,setSelectedCollectionInnerText] = useState({})
  const [confirmationVisibleForDeleteFromCollectionOnly, setConfirmationVisibleForDeleteFromCollectionOnly] = useState(false);
  const [confirmationVisibleForDeleteCards, setConfirmationVisibleForDeleteCards] = useState(false);
  const [confirmationVisibleCreateNewCollection,setConfirmationVisibleCreateNewCollection] = useState(false);
  const [createNewCollectionTitle,setCreateNewCollectionTitle] = useState("");
  const [confirmationVisibleDeleteCollection,setConfirmationVisibleDeleteCollection] = useState(false);
  const [confirmationVisibleRenameWatchList,setConfirmationVisibleRenameWatchList] = useState(false);
  const [renameCollectionTitle,setRenameCollectionTitle] = useState("");
  const [userResponse, setUserResponse] = useState(false);
  const [needToReset,setNeedToReset] = useState(false);
  const [isPcUpdate, setIsPcUpdate] = useState(false);
  const [isForSaleUpdate, setIsForSaleUpdate] = useState(false);
  const [isForTradeUpdate, setIsForTradeUpdate] = useState(false);
  const [isOnEbayUpdate, setIsOnEbayUpdate] = useState(false);
  const initialIsGoneChecked = {
    0: true,  // Default value for "No"
    1: false,  // Default value for "Yes"
  };
  const [isGoneChecked, setIsGoneChecked] = useState({});
 
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [totalCardValue,setTotalCardValue] = useState(0);
  const [totalCardLenght,setTotalCardLenght] = useState(0);
  const [searchBarSelectName,setSearchBarSelectName]= useState('')
  const [checkedCheckboxes, setCheckedCheckboxes] = useState({});
  const [singleCardOperationId,setSingleCardOperationId] = useState(0)
  const [thisUserCards,setThisUserCards] = useState([])
  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };
console.log('Here are cards : ',cards)
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  
  const filterCardsByUserId = async (userId,allCards) => {
    try {
      // Filter cards based on userId
      const filteredCards = allCards.filter((card) => card.UserId === userId);
      console.log('userId :',userId, 'filteredCards ', filteredCards,'allCards ', allCards)
      return filteredCards;
    } catch (error) {
      console.error('Error filtering cards by userId:', error);
      return [];
    }
  };

  const  getFilteredCardByThisUserId = async () =>{
    const filteredFromViewer = await filterCardsByUserId(userId,cards)
    console.log('it is filterredcardpretrade : ',filteredFromViewer)
     const isItDone = await setThisUserCards(filteredFromViewer)
   }
    useEffect (() => {
      if(userId !=null && cards.length>0)
      {getFilteredCardByThisUserId()
  console.log('I just did it :', userId,cards)}
        },[cards,userId])

        useEffect (() => {
         
      console.log('this is thisUserCards :', thisUserCards)
            },[thisUserCards])

  function formatDetails(option)
{
    let combineString = [];
    let index = 0
   // console.log('option ',option)
    if (option) {
        if (option.TypeOfCard)
        combineString[index] = ` Type      : ${option.TypeOfCard}  \n`;
    index+=1;
        combineString[index]= ` Player    : ${option.PlayerNames}  \n`;
        index+=1;
        // Add Set
        combineString[index]= ` Set       : ${option.SetNames}  \n`;
    
        // Add Attribute (if available)
        if (option.isOnlyAuto1||option.isOnlyRookie1||option.isOnlyRPA1||option.Number||option.isOnlyTrueRookie1) {
            index +=1;
            combineString[index]= ` Attribute : ${option.isOnlyTrueRookie1 ? '(OnlyTrueRookie) : Young Guns - FutureWatch - Spgu /JerseyNumber - Ice /99 ' : ''}${option.isOnlyRookie1 ? '(OnlyRookie)' : ''}${option.isOnlyRPA1 ? '(OnlyRPA)' : ''}${option.isOnlyAuto1 ? '(OnlyAuto)' : ''}${option.Number ? '(OnlyNumberedCard)' : ''}   \n`;
        }
        if (option.CardNames)
        {
            index +=1;
            combineString[index]=  ` Card      : ${option.CardNames}  \n`;
        }
        // Add Variation (if available)
        if (option.VariationNames) {
            index +=1;
            combineString[index]= ` Variation : ${option.VariationNames}  \n`;
        }
    
        if (option.OtherDetails) {
            index +=1;
            combineString[index]= ` Other     : ${option.OtherDetails}  \n`;
        }
      }
     // console.log('combineString',combineString)
      return combineString
}
  //-----------------------------------------------FetchData(Get)---------------------------------------------------
  //----------------------Get Collections----------------------
  function fetchCollectionsCards() {
    // Perform the API call to get the collections
    // Replace 'apiEndpoint' with your actual API endpoint
    fetch(
      `${process.env.REACT_APP_API_BASE}/api/collection/getCollectionUserCards/${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        const formattedData = formatData(data);
        // Update the collections state with the data from the API response
        setAllCollectionCards(formattedData);
       
      })
      .catch((error) => {
        // Handle the error
        console.error("Error fetching collections:", error);
      });
  }
  const formatData = (data) => {
    return data.map((item) => ({
      userCardId: item.userCardId,
      ListId: item.ListId,
    }));
  };
  //----------------------Get CardsForUser----------------------
  function fetchCollections() {
    // Perform the API call to get the collections
    // Replace 'apiEndpoint' with your actual API endpoint
    fetch(`${process.env.REACT_APP_API_BASE}/api/collection/getCollectionUser/${userId}`)
      .then((response) => response.json())
      .then((data) => {
        // Update the collections state with the data from the API response
        setCollections(data);
      })
      .catch((error) => {
        // Handle the error
        console.error("Error fetching collections:", error);
      });
  }

  function fetchRecentlyDeletedCards() {
    fetch(`${process.env.REACT_APP_API_BASE}/api/card/getRecentlyDeletedCards/${userId}`)
      .then((response) => response.json())
      .then((data) => {
        // Update the collections state with the data from the API response
        
        setRecentlyDeletedCards(data);
      })
      .catch((error) => {
        // Handle the error
        console.error("Error fetching recently deleted cards:", error);
      });
  }
  //----------------------End Get Collections/User----------------------
  //----------------------UseEffectToAssign(Cards/Collections)-------------------
  useEffect(() => {
    // Make the API call to fetch the collections
    fetchCollections();
    fetchCollectionsCards();

    console.log('filtered card 154', filteredCards)
   // fetchRecentlyDeletedCards();
   // console.log("recentlyDeletedCards", recentlyDeletedCards);
    console.log(allCollectionCards);
  }, []);


  useEffect(() => {
    // Check if the effect has already run
    if (!hasEffectRunRef.current) {
      // Perform your one-time setup or side effect here
      // ...
      setCheckedCheckboxes({No:true})
      setFilterValues({isGone:{No:true}})
      // Update the ref to indicate that the effect has run
      hasEffectRunRef.current = true;
    }
  }, []);

  useEffect (() => {
    console.log('isGoneChecked ',isGoneChecked)
    console.log('checkedCheckboxes', checkedCheckboxes)
      },[isGoneChecked])

  useEffect (() => {
console.log('-------------',filterValues)
  },[filterValues])



  //----------------------End UseEffectToAssign(Cards/Collections)-------------------
  //-----------------------------------------------End Of FetchData(Get)---------------------------------------------------
  //-----------------------------------------------HandleSingleAction---------------------------------------------------
 

//-----------------------------------------------End - HandleSingleAction---------------------------------------------------
  //-----------------------------------------------actionCreateNewCollection - Handle - FetchData(Post)/CreateCollectionThenAssign---------------------------------------------------
  function handleCreateNewCollection(isConfirmed) {
    console.log("Creating a collection and assigning to it");
    const collectionTitle = createNewCollectionTitle; // Replace with your input or dynamic value
    if (isConfirmed) {
      fetch("https://projet-collect-v1-production.up.railway.app/api/collection/add/collection", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, collectionTitle }),
      })
        .then((response) => response.json())
        .then((data) => {
          const { listId } = data;
          console.log("Created list ID:", listId);
          console.log("Created list Title:", collectionTitle);
          insertIntoCardsCardsList(listId);
          fetchCollections();
          fetchCollectionsCards();
          setCreateNewCollectionTitle("");
          setSelectedAction1("");
        })
        .catch((error) => {
          console.error("Error creating list:", error);
        });
    }
  }

  function handleRenameCollection(isConfirmed) {
    console.log("renaming the collection with id:", selectedCollectionLive);
    const collectionTitle = renameCollectionTitle; // Replace with your input or dynamic value
    if (isConfirmed) {
      fetch("https://projet-collect-v1-production.up.railway.app/api/collection/rename/watchlist", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId,
          collectionTitle,
          selectedCollectionLive,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          const { watchlistId } = data;

          console.log("Renamed list", " Title:", collectionTitle);
          setRenameCollectionTitle("");
          setConfirmationVisibleRenameWatchList(false);
        })
        .catch((error) => {
          console.error("Error renaming list:", error);
        });
    }
  }
  //-----------------------------------------------FetchData(Post)/AddCardToCollection---------------------------------------------------
  // Function to insert into cards_cardslist table
  function insertIntoCardsCardsList(listId) {
    const requestData = {
      listId: listId,
      cardIds: selectedCards,
    };

    fetch("https://projet-collect-v1-production.up.railway.app/api/collection/add/card", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Card inserted into cards_cardslist table");
      })
      .catch((error) => {
        console.error("Error inserting card into cards_cardslist:", error);
      });
  }
  //-----------------------------------------------FetchData(Delete)/CardFromCollection---------------------------------------------------
  // Function to delete from cards_cardslist table
  function removeFromCardsCardsList(confirmationIs) {

    let cardIds = [...selectedCards];
    if(singleCardOperationId !==0)
    cardIds = [singleCardOperationId];


    const requestData = {
      listId: selectedCollectionLive,
      cardIds: cardIds,
    };
    // Handle user's response
    const handleUserResponse = (response) => {
      if (response) {
        fetch("https://projet-collect-v1-production.up.railway.app/api/collection/remove/card", {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Cards deleted from cards_cardslist table");
            setConfirmationVisibleForDeleteFromCollectionOnly(false);
            setSelectedCards([]);
            fetchCollectionsCards();
            fetchCollections();
            setNeedToReset(!needToReset);
            setSingleCardOperationId(0)
          })
          .catch((error) => {
            console.error("Error deleting cards from cards_cardslist:", error);
            setConfirmationVisibleForDeleteFromCollectionOnly(false);
          });
      } else {
        console.log("Delete operation canceled by the user");
        setConfirmationVisibleForDeleteFromCollectionOnly(false);
      }
    };
    // Handle user's response based on the confirmationIs value
    handleUserResponse(confirmationIs);
  }

  //-----------------------------------------------FetchData(Put)/UpdateCardsStatus---------------------------------------------------
  function updateStatusForCards(confirmationToUpdateStatus) {
    const requestData = {
      userId: userId,
      cardIds: selectedCards,
      isPcUpdate: isPcUpdate,
      isForSaleUpdate: isForSaleUpdate,
      isForTradeUpdate: isForTradeUpdate,
      isOnEbayUpdate: isOnEbayUpdate,
    };

    fetch("https://projet-collect-v1-production.up.railway.app/api/collection/update/status", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Status updated for cards");
        // Handle the response data if needed
      })
      .catch((error) => {
        console.error("Error updating status for cards:", error);
      });
  }

  //-----------------------------------------------Filters---------------------------------------------------
  useEffect(() => {
    
   // console.log("isViewCollection : ", isViewCollection);

    const filterBy = Object.entries(filterValues).filter(([key, value]) => {
      if (key === "minPrice" || key === "maxPrice") {
        return value !== "";
      }
      const checkedValues = Object.entries(value)
        .filter(([k, v]) => v === true)
        .map(([k, v]) => k);
      return checkedValues.length > 0;
    });

    const isCardMatched = (card) => {
      if (

        filterBy.every(([key, value]) => {
        
          if (key === "minPrice") {
            return (
              value === "" ||
              parseFloat(card.EstimateValue) >= parseFloat(value)
            );
          }
          if (key === "maxPrice") {
            return (
              value === "" ||
              parseFloat(card.EstimateValue) <= parseFloat(value)
            );
          }
          if (key === "title" && value === null) {
            return value === "Not assigned";
          }
          const checkedValues = Object.entries(value)
            .filter(([k, v]) => v === true)
            .map(([k, v]) => k);
          return checkedValues.includes(String(card[key]));
        })
      ) {
        if (isViewCollection) {
          // return selectedCollectionCards.some((item) => parseInt(item.userCardId) === parseInt(card.id));
          return selectedCollectionCards.some(
            (item) => parseInt(item.userCardId) === parseInt(card.id)
          );
        } else {
          return true;
        }
      }
      return false;
    };

    setFilteredCards(cards.filter(isCardMatched));
    const totalValue = cards.filter(isCardMatched).reduce((sum, card) => {
      return sum + parseFloat(card.EstimateValue);
    }, 0);
    const totalLength = cards.filter(isCardMatched).length
    
    setTotalCardLenght(totalLength)
    setTotalCardValue(totalValue);
    console.log('je suis filterValues', filterValues)
  }, [
    cards,
    filterValues,
    isViewCollection,
    selectedCollectionCards,
    needToReset,
  ]);
  //--------------------------------------------End of useEffect for filters---------------------------------------------------

  function filterCardBySelectedCollection(selectedListId) {
    setTempoCards(cards);

    const filteredData = allCollectionCards.filter(
      (item) => parseInt(item.ListId) === parseInt(selectedListId)
    );
    setSelectedCollectionCards(filteredData);
    console.log("setSelectedColelction 289", filteredData);
    console.log("allcollectioncards 291", allCollectionCards);
    setIsViewCollection(true);
  }

  function resetFilters() {
    // Uncheck all checkboxes
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Clear all text inputs
    const inputs = document.querySelectorAll('input[type="text"]');
    inputs.forEach((input) => {
      input.value = "";
    });
    console.log('checkedbox',checkedCheckboxes)
    setCheckedCheckboxes({})
    setFilterValues({})
  }
  //-----------------------------------------------End Of Filters + Prepare rendering---------------------------------------------------

  //-----------------------------------------------Counts for filters---------------------------------------------------

  useEffect(() => {
    const counts = {
      Name: {},
      SetName: {},
      TeamsId:{},
      YearMade: {},
      cardName: {},
      variationName: {},
      IsRookie: {},
      IsPatch: {},
      IsJersey: {},
      IsAuto: {},
      isForSale: {},
      isPC: {},
      isForTrade: {},
      isOnEbay: {},
      isGone: {},
      Graded: {},
      GradeCompany: {},
      Grade: {},
    };

    filteredCards.forEach((card) => {
      Object.keys(counts).forEach((key) => {
        if (!counts[key][card[key]]) {
          counts[key][card[key]] = 0;
        }
        counts[key][card[key]]++;
      });
    });

    setNameCounts(counts.Name);
    setSetCounts(counts.SetName);
    setTeamsIdCounts(counts.TeamsId);
    setCardNameCounts(counts.cardName);
    setVariationNameCounts(counts.variationName);
    setYearCounts(counts.YearMade);
    setIsRookieCounts(counts.IsRookie);
    setIsPatchCounts(counts.IsPatch);
    setIsJerseyCounts(counts.IsJersey);
    setIsAutoCounts(counts.IsAuto);
    setIsForSaleCounts(counts.isForSale);
    setIsPCCounts(counts.isPC);
    setIsForTradeCounts(counts.isForTrade);
    setIsOnEbayCounts(counts.isOnEbay);
    setIsGoneCounts(counts.isGone);
    setIsGradedCounts(counts.Graded);
    setGradeCompanyCounts(counts.GradeCompany);
    setGradeCounts(counts.Grade);
  }, [filteredCards]);

  //-----------------------------------------------End Of Counts for filters---------------------------------------------------

  //-----------------------------------------------Handle---------------------------------------------------
  const handleFilterChange = (event) => {
    const { name, value, checked } = event.target;
  
    console.log('name, value, checked ',name, value, checked )

 console.log('checkcheckedboxlist',checkedCheckboxes)
 console.log('filtervalues',filterValues)
  /*  
 if (name === "isGone") {
      setIsGoneChecked((prevState) => ({
        ...prevState,
        [name]: checked ? true : false,
      }));
    }
  */
    if (name === "isGraded") {
      setFilterValues((prevState) => ({
        ...prevState,
        [name]: checked ? true : null,
      }));
    } else {
      
       // Update the checked checkboxes state
       setCheckedCheckboxes((prevState) => ({
        ...prevState,
        [value]: !checkedCheckboxes[value],
      }));
      // Handle checkbox change in category filters
      setFilterValues((prevState) => {
        const updatedFilters = { ...prevState[name] };
  
        if (checked) {
          updatedFilters[value] = true;
        } else {
          // If unchecked, remove the filter
          delete updatedFilters[value];
          // Check if the category is now empty, and if so, remove the category
          if (Object.keys(updatedFilters).length === 0) {
            const updatedState = { ...prevState };
            delete updatedState[name];
            return updatedState;
          }
        }
  
        return {
          ...prevState,
          [name]: updatedFilters,
        };
      });
    }
  };
  
  const handleSearchFilterChange = (event) => {
    const { name, value, checked } = event.target;
  
    // Access the selected option element
    const selectedOption = event.target.options[event.target.selectedIndex];
  
    // Access the 'name' attribute of the selected option
    const optionName = selectedOption.getAttribute('name');
  
    console.log('value : ', value);
    console.log(optionName);
  
      // Update the checked checkboxes state
      setCheckedCheckboxes((prevState) => ({
        ...prevState,
        [value]: true,
      }));


   /* if (optionName === "isGone" || optionName === "isGraded") {
      // Handle checkbox change for 'isGone' and 'isGraded' categories
      setFilterValues((prevState) => ({
        ...prevState,
        [optionName]: checked ? true : null,
      }));
    } else {*/
      // Handle checkbox change in other categories
      setFilterValues((prevState) => {
        const updatedFilters = { ...prevState[optionName] };
        updatedFilters[value] = true;

      /*  if (checked) {
          updatedFilters[value] = true;
        } else {
          // If unchecked, remove the filter
          delete updatedFilters[value];
  
          // Check if the category is now empty, and if so, remove the category
          if (Object.keys(updatedFilters).length === 0) {
            const updatedState = { ...prevState };
            delete updatedState[optionName];
            return updatedState;
          }
        }*/
  
        return {
          ...prevState,
          [optionName]: updatedFilters,
        };
      });
    //}
  };
  



  const removeFilter = (category, filter) => {
    const updatedFilters = { ...filterValues };
    const updatedCheckedCheckboxes = { ...checkedCheckboxes };
    
    // Remove the filter from the category in filterValues
    delete updatedFilters[category][filter];
  
    // Remove the filter from the category in checkedCheckboxes
    setCheckedCheckboxes((prevState) => ({
      ...prevState,
      [filter]: !checkedCheckboxes[filter],
    }));
    
    // If the category is empty in filterValues, remove the entire category
    if (Object.keys(updatedFilters[category]).length === 0) {
      delete updatedFilters[category];
    }
  
    // If the category is empty in checkedCheckboxes, remove the entire category
    setFilterValues(updatedFilters);
  
    console.log('Removed filter:', filter, 'from category:', category);
  
    // Uncheck the checkbox corresponding to the filter
    /* const checkbox = document.querySelector(`input[type="checkbox"][name="${category}"][value="${filter}"]`);
    if (checkbox) {
      checkbox.checked = false;
    }*/
  
    // Clear the input field corresponding to the filter
    const inputField = document.querySelector(`input[type="text"][id="${filter}"]`);
    if (inputField) {
      inputField.value = '';
    }
  };
  
  // Function to clear all filters in a category
  const clearCategory = (category) => {
    const updatedFilters = { ...filterValues };
    console.log('update ', updatedFilters[category]);
  
    const updatedCheckedCheckboxes = { ...checkedCheckboxes };
    console.log('checkbox', updatedCheckedCheckboxes);
  
    // Iterate through the keys (names) in updatedCheckedCheckboxes
    for (const key in updatedCheckedCheckboxes) {
      if (updatedFilters.hasOwnProperty(category) && updatedFilters[category].hasOwnProperty(key)) {
        console.log(true, 'key : ', key, 'category : ', category);
        // If the key matches the category, delete it from the updatedCheckedCheckboxes
        delete updatedCheckedCheckboxes[key];
      } else {
        console.log(false, 'key : ', key, 'category : ', category);
      }
    }

  delete updatedFilters[category];
  setFilterValues(updatedFilters);
  // Update the checkedCheckboxes state with the modified object
  setCheckedCheckboxes(updatedCheckedCheckboxes);

  const checkboxes = document.querySelectorAll(`input[type="checkbox"][name="${category}"]`);
  console.log('checkechk',checkboxes)
  checkboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });
 

  // Clear input fields associated with the category name
  const inputFields = document.querySelectorAll(`input[type="text"][id="${category}"]`);
  inputFields.forEach((input) => {
    input.value = '';
  });
};


  const handleCardClick = (card) => {
    if (multiEditState) {
      // Add or remove the card ID from selectedCards based on its presence
      setSelectedCards((prevSelectedCards) => {
        const isSelected = prevSelectedCards.includes(card.id);
        if (isSelected) {
          return prevSelectedCards.filter((id) => id !== card.id);
        } else {
          console.log(selectedCards);
          return [...prevSelectedCards, card.id];
        }
      });
    } else {
      setSelectedCard(card);
      navigate(`/cards/${card.id}`, {
        state: {
          id: card.CardId,
          name: card.Name,
          imageUrl: card.Image,
          set: card.SetName,
          value: card.EstimateValue,
          condition: card.ConditionCard,
        },
      });
    }
  };

  function handleChangeCollectionLive(listIdProvided,listTitleProvided,innerText) {
    setSelectedCollectionLive(listIdProvided);
    setSelectedCollectionTitle(listTitleProvided);
    console.log('listTitleProvided ',listTitleProvided)
    console.log('listIdProvided',listIdProvided)
    console.log('innerText',innerText)
    setSelectedCollectionInnerText(innerText);
    // Perform any other necessary actions or validations

    console.log("listidprovided : ", listIdProvided);
    if (listIdProvided) {
      // Filter cards based on the selected collection
      filterCardBySelectedCollection(listIdProvided);
      setIsViewCollection(true);
      setSelectedCards([]);
    } else {
      // Reset the filter and show all cards
      setSelectedCollectionCards([]);
      setIsViewCollection(false);
      setFilteredCards(cards);
      resetFilters();
      setSelectedCards([]);
    }
  }

  function handleCancelCreateCollection() {
    setConfirmationVisibleCreateNewCollection(false);
    setCreateNewCollectionTitle("");
    setSelectedAction1("Select Action null");
  }

  function handleAssignToCollectionCancelButtonClick() {
    setSelectedAction1("Select Action null");
  }

  function handleCancelRenameCollection() {
    setConfirmationVisibleRenameWatchList(false);
    // setCreateNewCollectionTitle('');
  }
  //-----------------------------------------------HandleUpdateStatusChange---------------------------------------------------
  const handleUpdateStatusChange = (event) => {
    const { name, checked } = event.target;

    switch (name) {
      case "isPcUpdate":
        setIsPcUpdate(checked);
        break;
      case "isForSaleUpdate":
        setIsForSaleUpdate(checked);
        break;
      case "isForTradeUpdate":
        setIsForTradeUpdate(checked);
        break;
      case "isOnEbayUpdate":
        setIsOnEbayUpdate(checked);
        break;
      default:
        break;
    }
  };

  //-------------------HandleUpdateStatusButtonClick
  const handleUpdateStatusCancelButtonClick = () => {
    setIsForSaleUpdate(false);
    setIsForTradeUpdate(false);
    setIsOnEbayUpdate(false);
    setIsPcUpdate(false);
    setSelectedAction1("Select Action null");
  };
  const handleUpdateStatusButtonClick = () => {
    // Update values in the database
    // Use the state variables (isPcUpdate, isForSaleUpdate, etc.) to send the updated values
    // Call the API endpoint and handle the response
    updateStatusForCards(true);
    // Reset the state variables
    setIsForSaleUpdate(false);
    setIsForTradeUpdate(false);
    setIsOnEbayUpdate(false);
    setIsPcUpdate(false);
    setSelectedAction1("Select Action null");
  };

  //----------------------------------------------Start of Group actions---------------------------------------------------
  const handleMultiEditButton = () => {
    // Perform the group action using the selectedCards array
    if (multiEditState) {
      setMultiEditState(false);
      setSelectedCards([]);
      console.log("set editState a false");
      setSelectedAction1("Select Action null");
    } else {
      setMultiEditState(true);
      console.log("set editState a true");
    }
  };
  //---------------------------------------------- actionAssignToCollection - Display collection choice to assign------------------------------------------------
  function displayCreateCollectionForm() {
    // Render the form elements (dropdown and confirm button)
    const createCollectionLabel = (
      <div>
        <label htmlFor="createCollection">Creating a new collection</label>
      </div>
    );
    const collectionNameInput = (
      <input
        type="text"
        value={createNewCollectionTitle}
        onChange={(e) => setCreateNewCollectionTitle(e.target.value)}
        placeholder="Enter a name for the collection"
      />
    );
    /*handleCreateNewCollection()*/
    const confirmButton = (
      <button onClick={() => handleCreateNewCollection(true)}>Confirm</button>
    );
    const cancelButton = (
      <button onClick={() => handleCancelCreateCollection()}>Cancel</button>
    );
    return (
      <div>
        {createCollectionLabel}
        {collectionNameInput}
        {confirmButton}
        {cancelButton}
      </div>
    );
  }

  function displayRenameCollectionForm() {
    // Render the form elements (dropdown and confirm button)
    const renameCollectionLabel = (
      <div>
        <label htmlFor="renameCollection">Rename this collection</label>
      </div>
    );
    const collectionNameInput = (
      <input
        id="id"
        type="text"
        value={renameCollectionTitle}
        onChange={(e) => setRenameCollectionTitle(e.target.value)}
        placeholder="Enter a new name for this collection"
      />
    );
    /*handleCreateNewCollection()*/
    const confirmButton = (
      <button onClick={() => handleRenameCollection(true)}>Confirm</button>
    );
    const cancelButton = (
      <button onClick={() => handleCancelRenameCollection()}>Cancel</button>
    );
    return (
      <div>
        {renameCollectionLabel}
        {collectionNameInput}
        {confirmButton}
        {cancelButton}
      </div>
    );
  }

  function displayAssignToCollectionForm() {
    // Render the form elements (dropdown and confirm button)
    console.log(collections);
    const collectionSelect = (
      <select
        value={selectedCollection}
        onChange={(e) => setSelectedCollection(e.target.value)}
      >
        <option value="">Select a collection</option>
        {/* Populate with existing collections */}
        {collections.map((collection) => (
          <option key={collection.ListId} value={collection.ListId}>
            {`${collection.Title} (${collection.collectionCount})`}
          </option>
        ))}
      </select>
    );

    const confirmButton = (
      <button onClick={handleAssignToCollection}>Confirm</button>
    );
    const cancelButton = (
      <button onClick={() => handleAssignToCollectionCancelButtonClick()}>
        Cancel
      </button>
    );
    return (
      <div>
        {collectionSelect}
        {confirmButton}
        {cancelButton}
      </div>
    );
  }
  
  
  //---------------------------------------------- actionAssignToCollection - Insert into collection------------------------------------------------
  function handleAssignToCollection() {
    console.log("selected en dessous");
    console.log(selectedCollection);
    insertIntoCardsCardsList(selectedCollection);
    setSelectedAction1("");
  }
  //---------------------------------------------- actionChangeStatus - Change status------------------------------------------------
  function performAction3() {
    console.log("Performing Action 3");
    // Add your code for Action 3 here
  }

  function premadeExport() {
    console.log("export");
    console.log("im exporting selectedCards", selectedCards);
    const ExportingCards = selectedCards;
    navigate(`/MainExport`, {
      state: {
        userCardIds: ExportingCards,
        userId: userId,
      },
    });
  }

  //---------------------------------------------- Groupe actions - Handle------------------------------------------------
  function handleGroupAction(event) {
    const selectedAction = event.target.value;
    setSelectedAction1(selectedAction);
    event.target.selectedIndex = 0;
    // Execute the associated function based on the selected action
    switch (selectedAction) {
      case "actionAssignToCollection":
        //  AssignToCollection();
        displayAssignToCollectionForm();
        break;
      case "actionCreateNewCollection":
        displayCreateCollectionForm();
        break;
      case "actionChangeStatus":
        performAction3();
        break;
      case "export":
        premadeExport();

      case "actionDeleteFromCollection":
        //removeFromCardsCardsList(selectedCollectionLive);
        setConfirmationVisibleForDeleteFromCollectionOnly(true);
        break;
      case "actionDeleteFromAll":
        setConfirmationVisibleForDeleteCards(true);
        break;
      default:
        // Handle default case or do nothing
        break;
    }
    console.log("Selected cards:", selectedCards);
    console.log(selectedAction);
    console.log(confirmationVisibleForDeleteFromCollectionOnly);
  }

  //----------------------------------------------End of Group actions---------------------------------------------------
  //----------------------------------------------End of Handle---------------------------------------------------

 //----------------------------------------------Start of Filter Unique---------------------------------------------------
let uniqueNames = [];
let uniqueSets = [];
let uniqueTeamsId = [];
let uniqueCardName = [];
let uniqueVariationName = [];
let uniqueYear = [];
let uniqueIsRookie = [];
let uniqueIsPatch = [];
let uniqueIsJersey = [];
let uniqueIsAuto = [];
let uniqueIsForSale = [];
let uniqueIsPC = [];
let uniqueIsForTrade = [];
let uniqueIsOnEbay = [];
let uniqueIsGone = [];
let uniqueIsGraded = [];
let uniqueGradeCompany = [];
let uniqueGrade = [];


if (cards.length > 0) {
  uniqueNames = [...new Set(cards.map((card) => card.Name))].sort();
  uniqueSets = [...new Set(cards.map((card) => card.SetName))].sort();
  uniqueTeamsId = [...new Set(cards.map((card) => card.TeamsId))].sort();
  uniqueCardName = [...new Set(cards.map((card) => card.cardName))].sort();
  uniqueVariationName = [...new Set(cards.map((card) => card.variationName))].sort();
  uniqueYear = [...new Set(cards.map((card) => card.YearMade))].sort();
  uniqueIsRookie = [...new Set(cards.map((card) => card.IsRookie))].sort();
  uniqueIsPatch = [...new Set(cards.map((card) => card.IsPatch))].sort();
  uniqueIsJersey = [...new Set(cards.map((card) => card.IsJersey))].sort();
  uniqueIsAuto = [...new Set(cards.map((card) => card.IsAuto))].sort();
  uniqueIsForSale = [...new Set(cards.map((card) => card.isForSale))].sort();
  uniqueIsPC = [...new Set(cards.map((card) => card.isPC))].sort();
  uniqueIsForTrade = [...new Set(cards.map((card) => card.isForTrade))].sort();
  uniqueIsOnEbay = [...new Set(cards.map((card) => card.isOnEbay))].sort();
  uniqueIsGone = [...new Set(cards.map((card) => card.isGone))].sort();
  uniqueIsGraded = [...new Set(cards.map((card) => card.Graded))].sort();
  uniqueGradeCompany = [...new Set(cards.map((card) => card.GradeCompany))]
    .filter((gradeCompany) => gradeCompany !== "")
    .sort();
  uniqueGrade = [...new Set(cards.map((card) => card.Grade))]
    .filter((grade) => grade !== 0)
    .sort();
} else {
  // Handle the case when cards is empty or null
  console.error("Error: cards is empty or null");
}
  const FilterGroup = ({ title, items, counts, checkedCheckboxes, handleFilterChange }) => {
    // Create two arrays: one for checked items and one for unchecked items
    let checkedItems=[];
    let uncheckedItems=[]; 
     const [isListOpen, setIsListOpen] = useState(true);
     const [showMoreFilter, setShowMoreFilter] = useState(false);
    // Fonction pour basculer l'état de la liste
    const toggleList = () => {
      setIsListOpen(!isListOpen);
    };
    const toggleShowMoreFilter = () => {
      setShowMoreFilter(!showMoreFilter);
    };
    if(items.length>0)
    {
     checkedItems = items.filter((item) => checkedCheckboxes[item]);
     uncheckedItems = items.filter((item) => !checkedCheckboxes[item]);
  

    // Sort both arrays by counts
    checkedItems.sort((a, b) => counts[b] - counts[a]);
    uncheckedItems.sort((a, b) => counts[b] - counts[a]);
   
}
  
    {/* <FilterGroup
    title="Variation Name"
    items={uniqueVariationName}
    counts={variationNameCounts}
    checkedCheckboxes={checkedCheckboxes}
    handleFilterChange={handleFilterChange}
  />*/}
    function FindTheTeamNameById(teamId) {
      const team = teams[teamId];
      return team ? team.name : 'Unknown Team';
    };




    const modifyLabel = (label) => {
      if (label === "NotisPC") { return "NotPC"; }
      else if (label === "isPC") { return "PC"; }
      else if (label === "NotisOnEbay") { return "NotOnEbay"; }
      else if (label === "isOnEbay") { return "OnEbay"; }
      else if (label === "NotisForTrade") { return "NotForTrade"; }
      else if (label === "isForTrade") { return "ForTrade"; }
      else if (label === "NotisForSale") { return "NotForSale"; }
      else if (label === "isForSale") { return "ForSale"; }
      else if (label === "Name") { return "Player"; }
      else if (label === "TeamsId") { return "Team(Uniform)"; }
      else if (label === "SetName") { return "Set"; }
      else if (label === "cardName") { return "Card"; }
      else if (label === "variationName") { return "Variation"; }
      else if (label === "YearMade") { return "Year"; }
      else if (label === "IsAuto") { return "Auto"; }
      else if (label === "IsRookie") { return "Rookie"; }
      else if (label === "IsPatch") { return "Patch"; }
      else if (label === "IsJersey") { return "Jersey"; }
      else if (label === "IsAuto") { return "Auto"; }
      else if (label === "GradeCompany") { return "GradingCompany"; }
      else {
        return label;
      }
    };
    return (
      <div className="filter-group">

        <div className='title' onClick={toggleList}>
          <h5>{title === 'isGone' ? 'RecentlyDeleted' : modifyLabel(title)}</h5>
          <svg className={isListOpen ? 'icon open' : "icon"} viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5 -6.11959e-07L6.53109 3.75L0.468912 3.75L3.5 -6.11959e-07Z" fill="#F5DAFF" />
          </svg>
        </div>
        <div className='list open'>  {checkedItems.map((item,index) => (
          <div className={index >= 5 && !showMoreFilter ? 'checkb hidden' : 'checkb'} key={item}>
            <input
              type="checkbox"
              name={title}
              value={item}
              checked={checkedCheckboxes[item] || false}
              onChange={handleFilterChange}
            />
            <label>


              {title === 'TeamsId' ? FindTheTeamNameById(item) : modifyLabel(item)}
            </label>
            <p style={{ marginLeft: "5px", color: "black" }}>
              ({counts[item] || 0})
            </p>
          </div>
        ))}
        {checkedItems.length > 5 && (
        <button onClick={() => toggleShowMoreFilter()} style={{marginTop: '10px'}}>
          {showMoreFilter ? 'Less' : 'More'}
        </button>
      )}
        
        </div>
        
        <div className={isListOpen ? 'list open' : "list"}>

          {uncheckedItems.map((item,index) => (
            <div className={index >= 5 && !showMoreFilter ? 'checkb hidden' : 'checkb'} key={item}>
              <input
                type="checkbox"
                name={title}
                value={item}
                checked={checkedCheckboxes[item] || false}
                onChange={handleFilterChange}
              />
              <label>{title === 'TeamsId' ? FindTheTeamNameById(item) : modifyLabel(item)}</label>
              <p style={{ marginLeft: "5px", color: "lightgray" }}>
                ({counts[item] || 0})
              </p>
            </div>
          ))}
            {uncheckedItems.length > 5 && (
        <button onClick={() => toggleShowMoreFilter()} style={{marginTop: '10px'}}>
          {showMoreFilter ? 'Less' : 'More'}
        </button>
      )}
        </div>

      </div>
    );
    
          }



 
  //-----------------------------------Test
  function deleteCardsFromAll(confirmationIs) {
    let cardIds = [...selectedCards];
    if(singleCardOperationId !==0)
    cardIds = [singleCardOperationId];
    console.log("CardIds to delete", cardIds);
    const handleUserResponse = (response) => {
      if (response) {
        // Perform the delete user account operation
        // ...
        fetch("https://projet-collect-v1-production.up.railway.app/api/remove/card", {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ cardIds }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data.message); // Assuming the API returns a success message
            // Perform additional actions after deleting the cards
            // ...
            setSingleCardOperationId(0)
          })
          .catch((error) => {
            console.error("Error deleting cards:", error);
          });
        console.log("Cards deleted");
      } else {
        console.log("Delete operation canceled by the user");
      }

      setConfirmationVisibleForDeleteCards(false);
    };

    handleUserResponse(confirmationIs);
  }

  //----------------------Delete watchlist and cards_watchlist

  function deleteCollection(isConfirmed) {
    if (isConfirmed) {
      const requestData = {
        listId: selectedCollectionLive,
        UserId: userId,
      };
      // Handle user's response
      console.log("This is it", selectedCollectionLive, userId);
      fetch("https://projet-collect-v1-production.up.railway.app/api/collection/remove/thisWatchList", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then(() => {
          console.log("Collection Deleted");
          fetchCollectionsCards();
          fetchCollections();
          setNeedToReset(!needToReset);
        })
        .catch((error) => {
          console.error("Error deleting this collection", error);
        });
      setConfirmationVisibleDeleteCollection(false);
    }
  }
  let currentCard;
  function handleSingleCardEditClick(card) {
   console.log(card)
   /*
  navigate(`/EditCard/${card.ID}`, {
    state: {
      userCardId: card.userCardId,
      cardId: card.CardId,
      cardName: card.cardName,
      IdCardVariation: card.IdCardVariation,
      IDVariation:card.IDVariation,
      fromSet : card.fromSet,
      cardVariation:card.variationName,
      ImageFront: card.ImageFront,
      ImageBack: card.ImageUserBack,
      setId:card.setId,
      set: card.SetName,
      TypeSet:card.TypeSet,
      YearMade:card.YearMade,
      value: card.EstimateValue,
      condition: card.ConditionCard,
      player: card.Name,
      playerId: card.PlayerId,
      RookieYear:card.RookieYear,
      graded: card.Graded==='Raw'?0:1,
      gradeCompany: card.GradeCompany,
      grade: card.Grade,
      paidPrice: card.PaidPrice,
      sport: card.Type,
      isPc:card.isPC==='isPC'?1:0,
      isForSale:card.isForSale==="NotisForSale"?0:1,
      isForTrade:card.isForTrade==="NotisForTrade"?0:1,
      isOnEbay:card.isOnEbay==="NotisOnEbay"?0:1,
      location:card.Location,
      condition:card.ConditionCard,
      isPatch:card.isPatch==='NotPatch'?0:1,
      isRookie:card.isRookie==='Rookie(RC)'?1:0,
      numbered:card.numbered,
      isAuto:card.isAuto==='NotAuto'?0:1,
      isJersey:card.isJersey==='NotJersey'?0:1,
       NumberBehind:card.NumberBehind,

    },
  });
*/
console.log('quebec')
  console.log('isPatch : ',card.IsPatch,' ',(card.IsPatch==='Patch'?1:0))
  console.log('IsRookie : ',card.IsRookie,' ',(card.IsRookie==='Rookie(RC)'?1:0))
  console.log('isauto : ',card.IsAuto,' ',(card.IsAuto==='Auto'?1:0))
  console.log('isJersey : ',card.IsJersey,' ',(card.IsJersey==='Jersey'?1:0))
  console.log('graded : ',card.Graded,' ', (card.Graded==='Raw'?0:1))
  console.log('card ',card)
navigate(`/EditCard/${card.id}`, {
    state: {
      userCardId: card.id,
      cardId: card.CardId,
      cardName: card.cardName,
      IdCardVariation: card.IdCardVariation,
      IDVariation:card.IDVariation,
      fromSet : card.fromSet,
      cardVariation:card.variationName,
      ImageFront: card.ImageFront,
      ImageBack: card.ImageUserBack,
      setId:card.setId,
      set: card.SetName,
      teamsId:card.teamsId,
      TypeSet:card.TypeSet,
      YearMade:card.YearMade,
      value: card.EstimateValue,
      condition: card.ConditionCard,
      player: card.Name,
      playerId: card.PlayerId,
      RookieYear:card.RookieYear,
      graded: card.Graded==='Raw'?0:1,
      gradeCompany: card.GradeCompany,
      grade: card.Grade,
      paidPrice: card.PaidPrice,
      sport: card.Type,
      isPc:card.isPC==='isPC'?1:0,
      isForSale:card.isForSale==="NotisForSale"?0:1,
      isForTrade:card.isForTrade==="NotisForTrade"?0:1,
      isOnEbay:card.isOnEbay==="NotisOnEbay"?0:1,
      location:card.Location,
      condition:card.ConditionCard,
      isPatch:card.IsPatch==="NotPatch"?0:1,
      isRookie:card.IsRookie==="Rookie(RC)"?1:0,
      numbered:card.numbered,
      isAuto:card.IsAuto==="NotAuto"?0:1,
      isJersey:card.IsJersey==="NotJersey"?0:1,
       NumberBehind:card.NumberBehind,
/*
 IsRookie: location.state.isRookie, 
  IsPatch: location.state.isPatch,
  IsAuto: location.state.isAuto,
  IsJersey: location.state.isJersey,*/
    },
  });
  

    nextOperation('Edit');
  }
  
  function handleSingleCardDeleteClick(userCardId) {
    setSingleCardOperationId(userCardId);
    nextOperation('DeleteFromAll');
  }
  
  function handleSingleCardRemoveFromWatchlistClick(userCardId) {
    setSingleCardOperationId(userCardId);
    nextOperation('DeleteFromWatchlist');
  }
  
  function nextOperation(operation) {
    switch (operation) {
      case 'Edit':
        console.log('Editing...');
        break;
      case 'DeleteFromAll':
        setConfirmationVisibleForDeleteCards(true);
        console.log('Deleting...');
        break;
      case 'DeleteFromWatchlist':
        setConfirmationVisibleForDeleteFromCollectionOnly(true);
        console.log('Removing from watchlist...');
        break;
      default:
        console.log('Invalid operation');
        break;
    }
  }

  function isValidStringForDeleteCollection(str) {
    return str !=="";
  }
  //-----------------------------------EndTest

  //Trading 
  const handleTrade = (offer) => {
    // Handle the trade logic here, e.g., send the offer to the server
    console.log('Trade Offer:', offer);
    // Additional logic for trade, if needed
    
  };


  //----------------------------------------------RenderJSX---------------------------------------------------
  if (userId===null) navigate(`/login`);
  else
  return (
    <div className="card-container">

      {isFilterVisible && (
        <div className="filter-container">
          <div className="card-grid-container">
          <select
            value={selectedCollectionLive}
            onChange={(e) =>
              handleChangeCollectionLive(
                e.target.value,
                e.target.options[e.target.selectedIndex].getAttribute('data-key'),
                e.target.options[e.target.selectedIndex].innerText
              )
            }
          >
            <option value="">Show All Cards </option>

            {/* Populate with existing collections */}
            {collections.map((collection) => (
              <option key={collection.Title} value={collection.ListId} data-key={collection.Title}>
                {`${collection.Title} (${collection.collectionCount})`}
              </option>
            ))}
          </select>
          {isValidStringForDeleteCollection(selectedCollectionLive) && (
            <button onClick={() => setConfirmationVisibleRenameWatchList(true)}>
              Rename
            </button>
          )}
          {confirmationVisibleRenameWatchList && displayRenameCollectionForm()}

          {isValidStringForDeleteCollection(selectedCollectionLive) && (
            <button
              onClick={() => setConfirmationVisibleDeleteCollection(true)}
            >
              Delete watchlist
            </button>
          )}

          <ConfirmationModal
            isVisible={confirmationVisibleDeleteCollection}
            onCancel={() => setConfirmationVisibleDeleteCollection(false)}
            onConfirm={() => deleteCollection(true)}
            message={`Are you sure you want to delete this watchlist : "${selectedCollectionInnerText}"?`}
          />

          <div>
            <button onClick={resetFilters}>Reset Filter</button>
          </div>
          <div className="filters-container">
        
      <h3> current Result <b>({totalCardLenght})</b></h3>
      <div className="filter-group">
       {/* <h2>Name</h2> <NameSelect uniqueNames={uniqueNames} selectedName={searchBarSelectName} setSelectedName={setSearchBarSelectName} handleSearchFilterChange={handleSearchFilterChange} Name={'Name'} /> */}
            
<FilterGroup
  title="Name"
  items={uniqueNames}
  counts={nameCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>
<FilterGroup
    title="TeamsId"
    items={uniqueTeamsId}
    counts={teamsIdCounts}
    checkedCheckboxes={checkedCheckboxes}
    handleFilterChange={handleFilterChange}
  />

<FilterGroup
    title="SetName"
    items={uniqueSets}
    counts={setCounts}
    checkedCheckboxes={checkedCheckboxes}
    handleFilterChange={handleFilterChange}
  />

  <FilterGroup
    title="cardName"
    items={uniqueCardName}
    counts={cardNameCounts}
    checkedCheckboxes={checkedCheckboxes}
    handleFilterChange={handleFilterChange}
  />

  <FilterGroup
    title="variationName"
    items={uniqueVariationName}
    counts={variationNameCounts}
    checkedCheckboxes={checkedCheckboxes}
    handleFilterChange={handleFilterChange}
  />


<FilterGroup
  title="YearMade"
  items={uniqueYear}
  counts={yearCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>

<FilterGroup
  title="IsRookie"
  items={uniqueIsRookie}
  counts={isRookieCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>

<FilterGroup
  title="IsPatch"
  items={uniqueIsPatch}
  counts={isPatchCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>

<FilterGroup
  title="IsJersey"
  items={uniqueIsJersey}
  counts={isJerseyCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>

<FilterGroup
  title="IsAuto"
  items={uniqueIsAuto}
  counts={isAutoCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>
    
    
<FilterGroup
  title="Graded"
  items={uniqueIsGraded}
  counts={isGradedCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>

<FilterGroup
  title="GradeCompany"
  items={uniqueGradeCompany}
  counts={gradeCompanyCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>

<FilterGroup
  title="Grade"
  items={uniqueGrade}
  counts={gradeCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>

              <div>
                {" "}
                <h2>Price Filter</h2>
                <label htmlFor="minPriceInput">Min Price:</label>
                <input
                  type="number"
                  id="minPriceInput"
                  value={filterValues.minPrice!==0?filterValues.minPrice:0}
                  onChange={(e) =>
                    setFilterValues({
                      ...filterValues,
                      minPrice: e.target.value,
                    })
                  }
                />
                <label htmlFor="maxPriceInput">Max Price:</label>
                <input
                  type="number"
                  id="maxPriceInput"
                  value={filterValues.maxPrice!==999999999?filterValues.maxPrice:''}
                  onChange={(e) =>
                    setFilterValues({
                      ...filterValues,
                      maxPrice: e.target.value,
                    })
                  }
                />
              </div>
<FilterGroup
  title="isPC"
  items={uniqueIsPC}
  counts={isPCCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>


<FilterGroup
  title="isForSale"
  items={uniqueIsForSale}
  counts={isForSaleCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>
<FilterGroup
  title="isForTrade"
  items={uniqueIsForTrade}
  counts={isForTradeCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>
             
<FilterGroup
  title="isOnEbay"
  items={uniqueIsOnEbay}
  counts={isOnEbayCounts}
  checkedCheckboxes={checkedCheckboxes}
  handleFilterChange={handleFilterChange}
/>
        
              
<FilterGroup
    title="isGone"
    items={uniqueIsGone}
    counts={isGoneCounts}
    checkedCheckboxes={checkedCheckboxes}
    handleFilterChange={handleFilterChange}
/>
            </div>
          </div>

          <div>
            <h2>-----Group Action -------</h2>
          </div>
          <select
            onChange={handleGroupAction}
            disabled={!multiEditState || selectedCards.length === 0}
          >
            <option value="">Select an action for the selected cards</option>
            <option value="actionAssignToCollection">
              Assign to an existing collection
            </option>
            <option value="actionCreateNewCollection">
              Create a new collection
            </option>
            <option value="actionChangeStatus">
              Change the status (PC-ForTrade-ForSale)
            </option>
            <option value="export">Export those cards</option>
            {isViewCollection && (
              <option value="actionDeleteFromCollection">
                {" "}
                {`Delete those cards '(${selectedCards.length})' from this collection '${selectedCollectionTitle}' only`}
              </option>
            )}
            <option value="nothing"> </option>
            <option value="actionDeleteFromAll">{`Delete those cards '(${selectedCards.length})' from your entire portfolio.`}</option>
          </select>

          <p>Total Card Value: {totalCardValue.toFixed(2)} $</p>
          {/* Render the form elements conditionally */}
          {/*Confirmation dialog*/}

          {/*confirmationVisibleForDeleteFromCollectionOnly && (
        <div className="confirmation-modal">
          <p>
            {selectedCollectionLive === ''
              ? "Are you sure you want to delete the selected cards from your entire collection?"
              : `Are you sure you want to delete the selected cards from the collection: ${selectedCollectionTitle} (${selectedCards.length})?`}
          </p>
          <button onClick={() => removeFromCardsCardsList(true)}>Yes</button>
          <button onClick={() => removeFromCardsCardsList(false)}>No</button>
 </div>)*/}

          {/* Render the form elements conditionally */}
          {/*Confirmation dialog*/}
          <div>
            {/* Other JSX code */}

            <ConfirmationModal
              isVisible={confirmationVisibleForDeleteCards}
              onCancel={() => setConfirmationVisibleForDeleteCards(false)}
              onConfirm={() => deleteCardsFromAll(true)}
              message={`Are you sure you want to delete your selected cards(${singleCardOperationId !==0 ? 1:selectedCards.length}) from this portfolio?`}
            />

            {/* Other JSX code */}

            {/* Use the confirmation modal for the "Delete Card" action */}
            <ConfirmationModal
              isVisible={confirmationVisibleForDeleteFromCollectionOnly}
              onCancel={() =>
                setConfirmationVisibleForDeleteFromCollectionOnly(false)
              }
              onConfirm={() => removeFromCardsCardsList(true)}
              message={`Are you sure you want to delete the selected cards from the collection: ${selectedCollectionTitle} you are removing (${singleCardOperationId !==0 ? 1:selectedCards.length}) cards?`}
            />
          </div>

          {/*Confirmation dialog end*/}
          {/* Render the form elements conditionally */}

          {selectedAction1 === "actionCreateNewCollection" &&
            multiEditState &&
            displayCreateCollectionForm()}
          {selectedAction1 === "actionAssignToCollection" &&
            multiEditState &&
            displayAssignToCollectionForm()}
          {/* {selectedAction1 === "actionChangeStatus" &&
            multiEditState &&
            displayUpdateStatusForm()} */}

          <button onClick={handleMultiEditButton}>
            {!multiEditState
              ? "GroupSelection"
              : `UndoSelection (${selectedCards.length})`}
          </button>
        </div>
          {showMore && (
            <div>
              {/* Additional filter content for the second page */}
            </div>
          )}
          <button onClick={toggleShowMore}>
            {showMore ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )}


 


      
      <div className={`collection-container ${isFilterVisible ? 'with-filter' : ''}`}>
      <div>
      {/* Render FilterComponent and pass the removeFilter function */}
      <FilterComponent filterValues={filterValues} removeFilter={removeFilter} clearCategory={clearCategory}/>
    </div>
      <div className="card-grid-wrapper">
      
          {filteredCards.map((card) => (
             <div className='cardcontent'>
               <div> 
              <MoreOptionsButton
      onEditClick={() => handleSingleCardEditClick(card)}
      onDeleteClick={() => handleSingleCardDeleteClick(card.id)}
      onRemoveFromWatchlistClick={() => handleSingleCardRemoveFromWatchlistClick(card.id)}
      onMylisting={selectedCollectionTitle}
    />
    <InfoIcon infoData={formatDetails(card)}/>
   
      {thisUserCards.length>0 &&
        <TradeModals listingUserId={card.UserId} thisUserId={userId} prefilteredthisUserCards={thisUserCards} onTrade={handleTrade} liveCsrfToken={liveCsrfToken}  preSelectedCards={card}/>
      }
    </div>
  
     
  <div
    key={card.id}
    className={`card ${selectedCards.includes(card.id) ? "card-selected" : ""
      }`}
    onClick={() => handleCardClick(card)}
  >
    <div className='img'>
      
      <img className="card-image" src={card.Image} />
      <div className="filter"></div>
      <div className="card-isWhat">
        {card.IsRookie === 'Rookie(RC)' && (
          <div className='patch spe'>
            <p className='strong'>RC</p>
          </div>
        )}

        {card.Graded === "Graded" ?
          <div className='patch spe'>
            <p>{card.GradeCompany} - {card.Grade}</p>
          </div> : null
        }

        {card.IsPatch === 'Patch' && (
          <div className='patch'>
            <p>Patch</p>
          </div>
        )}

        {card.IsJersey === "Jersey" && (
          <div className='patch'>
            <p>Jersey</p>
          </div>
        )}

        {card.IsAuto === "Auto" && (
          <div className='patch'>
            <p>Auto</p>
          </div>
        )}
      </div>
    </div>
    <div className='txt'>
      <div className="justify">
        <p className="card-set">{card.SetName}</p>
        <p className="card-IDcard ">#{card.id}</p>
      </div>
      <h4 className="card-name">{card.Name}</h4>
      <div className='flex-h'>
        <p className="card-variation">{`${card.cardName} - ${card.variationName}`}</p>

        {card.Numbered === "" || card.Numbered === "0" ? null : <p className="card-numbered"> / {card.Numbered} </p>}

      </div>
      
    <div className="card-isfor">
      {card.isForSale === "isForSale" && (
        <div className='patch '>
          <p>ForSale</p>
        </div>
      )}

      {card.isPC === "isPC" && (
        <div className='patch '>
          <p>PC</p>
        </div>
      )}

      {card.isForTrade === "isForTrade" && (
        <div className='patch'>
          <p>ForTrade</p>
        </div>
      )}

      {card.isOnEbay === "isOnEbay" && (
        <div className='patch'>
          <p>OnEbay</p>
        </div>
      )}
    </div>
    <hr />
      <div className="justify bottom">
        <h4 className="card-value">{card.EstimateValue} $</h4>
        <div className='cta'>
          <h4>Voir</h4>
          <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.3333 10C11.3333 9.47 11.8525 8.67857 12.3781 8.01429C13.0539 7.15714 13.8614 6.40929 14.7872 5.83857C15.4813 5.41071 16.3228 5 17 5M17 5C16.3228 5 15.4806 4.58928 14.7872 4.16143C13.8614 3.59 13.0539 2.84214 12.3781 1.98643C11.8525 1.32143 11.3333 0.52857 11.3333 -1.41195e-06M17 5L-4.37114e-07 5" stroke="white" stroke-width="2" />
          </svg>

        </div>
      </div>
    </div>
    
    </div>
    </div>

))}
 </div>
          {selectedCard && <CardFullView card={selectedCard} />}
      </div>

      <button onClick={toggleFilter}>Toggle Filter</button>
    </div>
  );
}

export default CardGridTrade;